import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Store } from '@ngrx/store';
import * as StrategyActions from '../../strategy.actions';

import { toggleNotification } from '@shared/animations/shared.animations';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-strategy-interview-notification',
  templateUrl: './strategy-interview-notification.component.html',
  styleUrls: ['./strategy-interview-notification.component.scss'],
  animations: [toggleNotification('toggleNotification')],
  standalone: false
})
export class StrategyInterviewNotificationComponent {
  @Input() showNotification: boolean;
  @Output() showWidget = new EventEmitter<boolean>();

  constructor(
    private store: Store,
    private trackingService: TrackingService
  ) {}

  onOpen() {
    this.trackingService.trackActivity('[Button] Interview Notification: Learn more');
    this.showWidget.emit(true);
    this.store.dispatch(StrategyActions.disableInterviewNotification({ showWidget: true }));
  }

  onClose() {
    this.trackingService.trackActivity('[Button] Interview Notification: Close notification');
    this.showWidget.emit(false);
    this.store.dispatch(StrategyActions.disableInterviewNotification({ showWidget: false }));
  }
}
